import { render, staticRenderFns } from "./EmbryoTransfterForm.vue?vue&type=template&id=915052be&scoped=true&"
import script from "./EmbryoTransfterForm.vue?vue&type=script&lang=js&"
export * from "./EmbryoTransfterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915052be",
  null
  
)

export default component.exports